import { render } from "./LegalDefense.vue?vue&type=template&id=dbd32ffc&scoped=true"
import script from "./LegalDefense.vue?vue&type=script&lang=js"
export * from "./LegalDefense.vue?vue&type=script&lang=js"

import "./LegalDefense.vue?vue&type=style&index=0&id=dbd32ffc&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbd32ffc"]])

export default __exports__